import { useRef, useEffect } from 'react';
import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState';

// This is also defined in dataFunctions.ts. Not imported from database-constants to avoid circular dependencies.
const NEW_DATABASE_QUERY_PARAM = 'isNewDatabase';

// Custom React hook to detect + handle isNewDatabase query param.
export const useDatabaseQueryParamState = (contentId: string) => {
	// Gets the value of isNewDatabase query parameter
	const isNewDatabaseParam = createSingleQueryParamHook(NEW_DATABASE_QUERY_PARAM)();

	// Updates query params in URL
	const { setQueryParams } = useRouteActions();

	// storedValue will persist across renders via useRef
	const storedValue = useRef(isNewDatabaseParam);
	// if we navigate away to a different database or content type, this will help reset storedValue.
	const prevContentId = useRef(contentId);

	useEffect(() => {
		// If we navigate away to another database or content type, storedValue is reset.
		if (prevContentId.current !== contentId) {
			storedValue.current = undefined;
		}

		// If isNewDatabaseParam is true, store it in storedValue and remove it from URL (clears the isNewDatabase=true from URl!!)
		if (isNewDatabaseParam) {
			storedValue.current = isNewDatabaseParam;
			setQueryParams({ [NEW_DATABASE_QUERY_PARAM]: undefined }, true);
		}
	}, [isNewDatabaseParam, contentId, setQueryParams]);
	// Returns true if param was present during this session.
	return Boolean(storedValue.current);
};
